import { render, staticRenderFns } from "./studentExperience.vue?vue&type=template&id=241c0bc2&scoped=true"
import script from "./studentExperience.vue?vue&type=script&lang=js"
export * from "./studentExperience.vue?vue&type=script&lang=js"
import style0 from "./studentExperience.vue?vue&type=style&index=0&id=241c0bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c0bc2",
  null
  
)

export default component.exports